import { FETCH_SETTINGS_REQUEST_ASYNC as FETCH_GROUP_SETTINGS_REQUEST_ASYNC } from 'containers/GroupSettings/Wizard/constants'
import { COMPANY_FILTER_CHANGE } from 'containers/PartnerOptions/constants'

import { UPDATE_LANGUAGES_ASYNC } from '../Languages/constants'

import {
  CHANGE_BANNERS_LANGUAGE,
  CHANGE_FIELD,
  MAILBOX_PROTECTION_REQUEST_ASYNC,
  UPDATE_MAILBOX_PROTECTION_REQUEST_ASYNC,
} from './constants'

export default function () {
  const initialState = {
    loader: false,
    data: {},
    error: null,

    selectedBannersLanguage: null,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case CHANGE_BANNERS_LANGUAGE:
        return {
          ...state,
          selectedBannersLanguage: action.payload.value,
        }
      case UPDATE_LANGUAGES_ASYNC.SUCCESS:
        return {
          ...state,
          selectedBannersLanguage: null,
        }
      case CHANGE_FIELD:
        return {
          ...state,
          data: {
            ...state.data,
            ...(action.payload.selectedLang
              ? {
                  [action.payload.name]: {
                    ...state.data[action.payload.name],
                    texts: {
                      ...state.data[action.payload.name]?.texts,
                      [action.payload.selectedLang]: action.payload.value,
                    },
                  },
                }
              : {
                  [action.payload.name]: action.payload.value,
                }),
          },
        }
      case COMPANY_FILTER_CHANGE:
      case MAILBOX_PROTECTION_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true, error: null }
      case MAILBOX_PROTECTION_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          data: action.payload.data,
          loader: false,
        }
      case FETCH_GROUP_SETTINGS_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          data: action.payload.data?.impersonationProtection,
          loader: false,
        }
      case MAILBOX_PROTECTION_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case MAILBOX_PROTECTION_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false }
      case UPDATE_MAILBOX_PROTECTION_REQUEST_ASYNC.INITIATE:
        return { ...state, loader: true, error: null }
      case UPDATE_MAILBOX_PROTECTION_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          data: action.payload.data,
          loader: false,
        }
      case UPDATE_MAILBOX_PROTECTION_REQUEST_ASYNC.ERROR:
        return { ...state, error: action.error, loader: false }
      case UPDATE_MAILBOX_PROTECTION_REQUEST_ASYNC.CANCEL:
        return { ...state, loader: false }
      default:
        return state
    }
  }
}
